import { useSearchParams } from "react-router-dom";
import { getQueryParam, normalizeGuid, readCookie } from "@/utils/helper";

/**
 * Resolves the docId / uId a song order page runs on. uId falls back to the
 * signed-in user's cookie when the link omits it.
 */
export default function useSongOrderParams() {
  const [searchParams] = useSearchParams();

  return {
    docId: getQueryParam(searchParams, "docId"),
    // Normalize before the `||` so a malformed `uId` collapses to "" and falls
    // back to the signed-in user, rather than masking a valid cookie.
    userId:
      normalizeGuid(getQueryParam(searchParams, "uId")) ||
      normalizeGuid(readCookie("userguid")),
  };
}
